import React from 'react';
import { motion } from 'framer-motion';
import { Activity, Wind, BedDouble, Dumbbell } from 'lucide-react';
export function MechanismSection() {
  const pillars = [{
    icon: <Activity size={40} data-id="element-109" />,
    title: '1. Estabilidad de Glucosa',
    desc: 'Evita los picos de insulina que le dicen a tu cuerpo que almacene grasa en el abdomen. Aprende a comer para mantener energía constante.',
    color: 'bg-orange-50 text-orange-600 border-orange-200'
  }, {
    icon: <Wind size={40} data-id="element-110" />,
    title: '2. Reducción de Estrés',
    desc: "El cortisol alto bloquea la pérdida de peso. Técnicas simples para apagar la respuesta de 'lucha o huida' y reducir la inflamación.",
    color: 'bg-blue-50 text-blue-600 border-blue-200'
  }, {
    icon: <BedDouble size={40} data-id="element-111" />,
    title: '3. Sueño Profundo',
    desc: 'Es durante el sueño que tus hormonas se reparan. Protocolos para vencer el insomnio y lograr un descanso verdaderamente reparador.',
    color: 'bg-indigo-50 text-indigo-600 border-indigo-200'
  }, {
    icon: <Dumbbell size={40} data-id="element-112" />,
    title: '4. Movimiento Inteligente',
    desc: "Más cardio no es la respuesta. Descubre la 'señal muscular' adecuada para reactivar tu metabolismo sin agotar tus adrenales.",
    color: 'bg-health/10 text-health border-health/20'
  }];
  return <section className="py-24 px-4 bg-primary-contrast relative overflow-hidden" data-id="element-113">
      {/* Decorative background */}
      <div className="absolute top-0 right-0 w-1/2 h-full bg-white/40 skew-x-12 translate-x-20 pointer-events-none" data-id="element-114"></div>

      <div className="max-w-6xl mx-auto relative z-10" data-id="element-115">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-16 max-w-4xl mx-auto" data-id="element-116">
          <h2 className="text-3xl sm:text-4xl md:text-5xl font-serif font-bold text-text-primary mb-6" data-id="element-117">
            El problema no es que estés haciendo poco. El problema es que te
            enseñaron soluciones pensadas{' '}
            <span className="text-accent-dark" data-id="element-118">
              para otro momento de tu vida.
            </span>
          </h2>
          <p className="text-lg text-text-primary/80" data-id="element-119">
            Lo que funcionaba a los 25 ya no funciona a los 40. Tu cuerpo
            necesita un enfoque completamente nuevo basado en 4 pilares
            fundamentales para la mujer en peri-menopausia:
          </p>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8" data-id="element-120">
          {pillars.map((pillar, index) => <motion.div key={index} initial={{
          opacity: 0,
          scale: 0.95
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} className={`p-8 rounded-3xl border-2 bg-white/80 backdrop-blur-sm shadow-lg hover:shadow-xl transition-all flex flex-col sm:flex-row gap-6 items-start ${pillar.color.split(' ')[2]}`} data-id="element-121">
              <div className={`p-4 rounded-2xl shrink-0 ${pillar.color.split(' ')[0]} ${pillar.color.split(' ')[1]}`} data-id="element-122">
                {pillar.icon}
              </div>
              <div data-id="element-123">
                <h3 className="text-2xl font-bold text-text-primary mb-3" data-id="element-124">
                  {pillar.title}
                </h3>
                <p className="text-text-primary/70 leading-relaxed" data-id="element-125">
                  {pillar.desc}
                </p>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}